import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { AssignEntitiesEnum } from 'Common/FieldEnum';
import { SiteGroupGridContainer } from '../../containers/assignEntities/SiteGroupGridContainer';
import { ItemGridContainer } from '../../containers/assignEntities/ItemGridContainer';

const AssignItemToSiteGroups = props => {
  const {
    allItemsData,
    loadingAllItems,
    siteGroupData,
    loadingSiteGroup,
    setIsReadOnlyState,
    isReadOnly,
    onFilteredChange,
    rightSideGridReactTableRef,
    isRightGridFiltered,
    onResetPageOnDataChange,
    direction,
    resetGridPage,
  } = props;

  return (
    <Grid>
      <Grid.Row columns={2}>
        <Grid.Column width={6}>
          <Field
            component={ItemGridContainer}
            name={AssignEntitiesEnum.ItemGridInfo}
            {...{
              dataSource: allItemsData,
              loadingAllItems,
              isLeftSideItemGrid: true,
              isRightSideSiteGroupGrid: true,
              setIsReadOnlyState,
              isReadOnly,
              onResetPageOnDataChange,
              direction,
              resetGridPage,
            }}
          />
        </Grid.Column>
        <Grid.Column width={10}>
          <Field
            component={SiteGroupGridContainer}
            name={AssignEntitiesEnum.SiteGroupGridInfo}
            {...{
              dataSource: siteGroupData,
              loadingSiteGroup,
              isLeftSideItemGrid: true,
              isRightSideSiteGroupGrid: true,
              setIsReadOnlyState,
              isReadOnly,
              onFilteredChange,
              rightSideGridReactTableRef,
              isRightGridFiltered,
              onResetPageOnDataChange,
              direction,
              resetGridPage,
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

AssignItemToSiteGroups.propTypes = {
  allItemsData: PropTypes.array.isRequired,
  siteGroupData: PropTypes.array.isRequired,
  resetGridPage: PropTypes.object.isRequired,
  setIsReadOnlyState: PropTypes.func,
  onResetPageOnDataChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  isReadOnly: PropTypes.bool,
  direction: PropTypes.bool,
  loadingAllItems: PropTypes.bool,
  loadingSiteGroup: PropTypes.bool,
  rightSideGridReactTableRef: PropTypes.object,
  isRightGridFiltered: PropTypes.bool,
};

AssignItemToSiteGroups.defaultProps = {
  loadingAllItems: false,
  loadingSiteGroup: false,
  isReadOnly: true,
  direction: true,
  isRightGridFiltered: false,
  rightSideGridReactTableRef: null,
  setIsReadOnlyState: () => {},
  onResetPageOnDataChange: () => {},
  onFilteredChange: () => {},
};

export default AssignItemToSiteGroups;



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/components/assignEntities/AssignItemToSiteGroups.js